"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightRuleParameterType = void 0;
var DashboardInsightRuleParameterType;
(function (DashboardInsightRuleParameterType) {
    DashboardInsightRuleParameterType["String"] = "STRING";
    DashboardInsightRuleParameterType["StringArray"] = "STRING_ARRAY";
    DashboardInsightRuleParameterType["Number"] = "NUMBER";
    DashboardInsightRuleParameterType["Boolean"] = "BOOLEAN";
    DashboardInsightRuleParameterType["Date"] = "DATE";
})(DashboardInsightRuleParameterType = exports.DashboardInsightRuleParameterType || (exports.DashboardInsightRuleParameterType = {}));
//# sourceMappingURL=dashboard-insight-rule-parameters.js.map